<template>
    <div :style="{marginBottom: requiredTopMargin}">
        <div class="x-navbar">
            <div>
                <system-alerts></system-alerts>
                <trial-countdown></trial-countdown>
                <billing-alerts></billing-alerts>
            </div>
            <div class="x-navbar-row">
                <div class="x-navbar-group">
                    <a class="x-navbar-brand" href="/">
                        <img :src="'/assets/images/logo-crm-symbol.png' | asset" alt="Logotipo Microsistec"
                             width="37" height="30"/>
                    </a>
                </div>
                <div class="x-navbar-collapsable-menu" :class="{'x-navbar-collapsable-menu-visible': menuVisible}">
                    <div class="x-navbar-group x-navbar-primary">
                        <!--<div style="overflow-x: hidden; display: flex">
                            <div style="overflow: visible; display: flex">-->
                        <!-- forms -->
                        <div class="x-navbar-link x-navbar-dropdown"
                             :class="{active: match('/forms') || match('/calendar')}"
                             v-if="$can('view.customers') || $can('view.forms') || $can('view.calendars')">
                            <a :href="formsUrl"
                               data-close-others="true"
                               data-toggle="dropdown"
                               class="dropdown-toggle">
                                Funis
                                <span class="caret"></span>
                            </a>
                            <ul class="dropdown-menu">
                                <template v-if="funnels.length > 0">
                                    <li v-for="funnel in funnels">
                                        <a :href="'/forms/new/' + funnel.id">
                                            <span :style="{display: 'inline-block', width: '8px', height: '8px', borderRadius: '50%', marginRight: '6px', background: funnel.color}"></span>{{ funnel.name }}
                                        </a>
                                    </li>
                                    <li role="separator" class="divider"></li>
                                </template>
                                <li v-if="$can('view.customers') && funnels.length === 0">
                                    <a :href="formsUrl"><navbar-menu-icon name="flag"></navbar-menu-icon>Funil</a>
                                </li>
                                <li v-if="$can('view.forms')">
                                    <a href="/forms/lead-bank"><navbar-menu-icon name="inbox"></navbar-menu-icon>Banco de Leads</a>
                                </li>
                                <li class="divider" v-if="$can('view.calendars')"></li>
                                <li v-if="$can('view.calendars')">
                                    <a href="/calendar"><navbar-menu-icon name="calendar"></navbar-menu-icon>Atividades</a>
                                </li>
                            </ul>
                        </div>
                        <!-- customers -->
                        <div class="x-navbar-link x-navbar-dropdown"
                             :class="{active: match('/customers')}"
                             v-if="$can('view.customers') || $can('view_owners.properties')">
                            <a href="/customers"
                               data-close-others="true"
                               data-toggle="dropdown"
                               class="dropdown-toggle">
                                Clientes
                                <span class="caret"></span>
                            </a>
                            <ul class="dropdown-menu">
                                <li v-if="$can('view.customers')">
                                    <a href="/customers"><navbar-menu-icon name="usersGroup"></navbar-menu-icon>Todos
                                        <menu_counter name="customers.total"></menu_counter>
                                    </a>
                                </li>
                                <li v-if="$can('view.customers')">
                                    <a href="/customers/contacts"><navbar-menu-icon name="usersPair"></navbar-menu-icon>Clientes
                                        <menu_counter name="customers.contacts"></menu_counter>
                                    </a>
                                </li>
                                <li v-if="$can('view.customers') || $can('view_owners.properties')">
                                    <a href="/customers/owners"><navbar-menu-icon name="owners"></navbar-menu-icon>Proprietários
                                        <menu_counter name="customers.owners"></menu_counter>
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <!-- properties -->
                        <div class="x-navbar-link x-navbar-dropdown"
                             :class="{active: match('/properties')}"
                             v-if="$can('view.properties')">
                            <a href="/properties"
                               data-close-others="true"
                               data-toggle="dropdown"
                               class="dropdown-toggle">
                                Imóveis
                                <span class="caret"></span>
                            </a>
                            <ul class="dropdown-menu">
                                <li v-if="$can('add.properties')">
                                    <a href="/properties/add"><navbar-menu-icon name="plus"></navbar-menu-icon>Cadastrar imóvel</a>
                                </li>
                                <li>
                                    <a :href="propertySearchUrl"><navbar-menu-icon name="search"></navbar-menu-icon>Pesquisar imóveis
                                        <menu_counter name="properties.total"></menu_counter>
                                    </a>
                                </li>
                                <li v-if="$can('add.properties') && settings.properties['approval'] !== true">
                                    <a :href="propertyDraftsUrl"><navbar-menu-icon name="draft"></navbar-menu-icon>Rascunhos
                                        <menu_counter name="properties.is-draft"></menu_counter>
                                    </a>
                                </li>

                                <li v-if="preferences.searchVersion !== 2">
                                    <new-search-button :menu="true"></new-search-button>
                                </li>
                                <li v-if="settings.properties['approval'] === true">
                                    <a href="/properties/approval"><navbar-menu-icon name="approval"></navbar-menu-icon>Em Aprovação
                                        <menu_counter name="properties.in-approval"></menu_counter>
                                    </a>
                                </li>

                            </ul>
                        </div>
                        <!-- buildings -->
                        <div class="x-navbar-link x-navbar-dropdown"
                             :class="{active: match('/buildings')}"
                             v-if="$can('view.buildings')">
                            <a href="/properties"
                               data-close-others="true"
                               data-toggle="dropdown"
                               class="dropdown-toggle">
                                Empreendimentos
                                <span class="caret"></span>
                            </a>
                            <ul class="dropdown-menu">
                                <li v-if="$can('add.buildings')">
                                    <a href="/buildings/add"><navbar-menu-icon name="plus"></navbar-menu-icon>Cadastrar empreendimento</a>
                                </li>
                                <li>
                                    <a href="/buildings"><navbar-menu-icon name="search"></navbar-menu-icon>Pesquisar empreendimentos
                                        <menu_counter name="buildings.total"></menu_counter>
                                    </a>
                                </li>
                                <li v-if="$can('add.properties')">
                                    <a href="/buildings/search/eyJ0eXBlIjoyLCJkcmFmdCI6dHJ1ZX0="><navbar-menu-icon name="draft"></navbar-menu-icon>Rascunhos
                                        <menu_counter name="buildings.is-draft"></menu_counter>
                                    </a>
                                </li>
                                <li class="divider"></li>
                                <li>
                                    <a href="/buildings/developers"><navbar-menu-icon name="incorporadoras"></navbar-menu-icon>Incorporadoras
                                        <menu_counter name="customers.building-developers"></menu_counter>
                                    </a>
                                </li>
                                <li>
                                    <a href="/buildings/builders"><navbar-menu-icon name="construtoras"></navbar-menu-icon>Construtoras
                                        <menu_counter name="customers.building-builders"></menu_counter>
                                    </a>
                                </li>
                                <li>
                                    <a href="/buildings/managers"><navbar-menu-icon name="administradoras"></navbar-menu-icon>Administradoras
                                        <menu_counter name="customers.building-managers"></menu_counter>
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <!-- condominiums -->
                        <div class="x-navbar-link x-navbar-dropdown"
                             :class="{active: match('/condominiums')}"
                             v-if="$can('view.buildings')">
                            <a href="/condominiums"
                               data-close-others="true"
                               data-toggle="dropdown"
                               class="dropdown-toggle">
                                Condomínios
                                <span class="caret"></span>
                            </a>
                            <ul class="dropdown-menu">
                                <li v-if="$can('add.buildings')">
                                    <a href="/condominiums/add"><navbar-menu-icon name="plus"></navbar-menu-icon>Cadastrar condomínio</a>
                                </li>
                                <li>
                                    <a href="/condominiums"><navbar-menu-icon name="search"></navbar-menu-icon>Pesquisar condomínios
                                        <menu_counter name="condominiums.total"></menu_counter>
                                    </a>
                                </li>
                                <li v-if="$can('add.buildings')">
                                    <a href="/condominiums/search/eyJ0eXBlIjoxLCJkcmFmdCI6dHJ1ZX0="><navbar-menu-icon name="draft"></navbar-menu-icon>Rascunhos
                                        <menu_counter name="condominiums.is-draft"></menu_counter>
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <!-- reports -->
                        <div class="x-navbar-link x-navbar-dropdown"
                             :class="{active: match('/reports')}"
                             v-if="canSeeReports()">
                            <a href="/reports"
                               data-close-others="true"
                               data-toggle="dropdown"
                               class="dropdown-toggle">
                                Relatórios
                                <span class="caret"></span>
                            </a>
                            <ul class="dropdown-menu">
                                <li>
                                    <a href="/reports/new"><navbar-menu-icon name="reportAnalytics"></navbar-menu-icon>Analíticos
                                        <span class="badge badge-success">Novo</span>
                                    </a>
                                </li>
                                <li>
                                    <a href="/reports/forms"><navbar-menu-icon name="reportPerformance"></navbar-menu-icon>Inteligência</a>
                                </li>
                            </ul>
                        </div>
                        <!-- portals -->
                        <div class="x-navbar-link"
                             :class="{active: match('/portals')}"
                             v-if="$can('edit.portals') && portals.length < 1">
                            <a :href="portalsUrl">Portais</a>
                        </div>
                        <div class="x-navbar-link x-navbar-dropdown"
                             :class="{active: match('/portals')}"
                             v-if="$can('edit.portals') && portals.length > 0">
                            <a :href="portalsUrl"
                               data-close-others="true"
                               data-toggle="dropdown"
                               class="dropdown-toggle">
                                Portais
                                <span class="caret"></span>
                            </a>
                            <div class="dropdown-menu dropdown-menu-holder">
                                <div v-slimscroll style="max-height: 300px" height="">
                                    <ul class="dropdown-menu-list">
                                        <li>
                                            <a :href="portalsUrl"><navbar-menu-icon name="grid4"></navbar-menu-icon>Todos</a>
                                        </li>
                                        <li v-for="portal in portals">
                                            <a :href="portalUrl(portal.alias)"><span class="x-navbar-portal-badge" :class="'x-navbar-portal-badge-' + portalBadge(portal).variant" aria-hidden="true">{{ portalBadge(portal).initials }}</span>{{ portal.name }}</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <!-- I.A -->
                        <div class="x-navbar-link x-navbar-dropdown" v-if="settings.hasAlbert">
                            <a data-close-others="true"
                               data-toggle="dropdown"
                               class="dropdown-toggle">
                                I.A
                                <span class="caret"></span>
                            </a>
                            <ul class="dropdown-menu">
                                <li>
                                    <a v-show="settings.hasAlbert" href="/properties/outdated-reports" title="Atualização de imóveis"><navbar-menu-icon name="aiUpdate"></navbar-menu-icon>Atualizações de imóveis</a>
                                    <a v-show="!settings.hasAlbert" href="/instance/contrate" title="Atualização de imóveis"><navbar-menu-icon name="aiUpdate"></navbar-menu-icon>Atualizações de imóveis</a>
                                </li>
                            </ul>
                        </div>

                        <!-- Ajuda -->
                        <div class="x-navbar-link x-navbar-dropdown">
                            <a data-close-others="true"
                               data-toggle="dropdown"
                               class="dropdown-toggle">
                               Ajuda
                                <span class="caret"></span>
                            </a>
                            <ul class="dropdown-menu">
                                <li>
                                    <a target="_blank" href="http://suporte.microsistec.digital/" title="Suporte"><navbar-menu-icon name="faq"></navbar-menu-icon>Dúvidas Frequentes</a>
                                </li>
                                <li>
                                    <a href="https://microsistec-academy.memberkit.com.br" title="Microsistec Academy" target="_blank"><navbar-menu-icon name="academy"></navbar-menu-icon>
                                        Microsistec Academy
                                    </a>
                                </li>
                                <li v-if="$can('manager.billing')">
                                    <a href="/installments" title="2° Voa de boletos"><navbar-menu-icon name="invoice"></navbar-menu-icon>2° Via de boletos</a>
                                </li>
                            </ul>
                        </div>
                        <!--</div>
                    </div>-->
                    </div>
                    <div class="x-navbar-group x-navbar-tools">
                        <div class="x-navbar-link" v-if="website">
                            <a class="double-horizontal-padding"
                               :href="website['url']"
                               target="_blank"
                               data-toggle="tooltip"
                               title="Ver meu website"
                               v-tooltip
                               position="bottom">
                                <i class="fa fa-globe x-navbar-icon x-navbar-hide-collapsed"></i>
                                <span class="x-navbar-show-collapsed">Ver meu website</span>
                            </a>
                        </div>
<!--                        <div class="x-navbar-link">-->
<!--                            <a class="double-horizontal-padding"-->
<!--                               href="http://suporte.microsistec.digital/"-->
<!--                               target="_blank"-->
<!--                               data-toggle="tooltip"-->
<!--                               title="Suporte"-->
<!--                               v-tooltip-->
<!--                               position="bottom">-->
<!--                                <i class="fa fa-question-circle x-navbar-icon x-navbar-hide-collapsed"></i>-->
<!--                                <span class="x-navbar-show-collapsed">Suporte</span>-->
<!--                            </a>-->
<!--                        </div>-->

                    </div>
                </div>
                <div class="x-navbar-group x-navbar-collapsable-button-wrapper">
                    <button type="button" class="navbar-toggle" style="display: block" @click="toggleMenu()">
                        <span class="sr-only">Toggle navigation</span>
                        <span class="icon-bar" style="background: white"></span>
                        <span class="icon-bar" style="background: white"></span>
                        <span class="icon-bar" style="background: white"></span>
                    </button>
                </div>
                <div class="x-navbar-group">
                    <x-notifications></x-notifications>
                </div>
                <div class="x-navbar-group">
                    <x-tasks></x-tasks>
                </div>
                <div class="x-navbar-group x-navbar-settings">
                    <div class="x-navbar-link x-navbar-dropdown">
                        <a href="javascript:;" class="dropdown-toggle" data-toggle="dropdown" aria-label="Menu do sistema" title="Menu do sistema"
                           data-close-others="true">
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true">
                                <rect x="3" y="3" width="7" height="7" rx="1.4"></rect>
                                <rect x="14" y="3" width="7" height="7" rx="1.4"></rect>
                                <rect x="3" y="14" width="7" height="7" rx="1.4"></rect>
                                <rect x="14" y="14" width="7" height="7" rx="1.4"></rect>
                            </svg>
                            <span class="sr-only">Configurações</span>
                        </a>
                        <ul class="dropdown-menu x-navbar-mega-menu" style="left: auto; right: 0">
                            <li class="x-navbar-panel-header">
                                <span>Painel do sistema</span>
                                <span class="x-navbar-panel-tag">Configurações</span>
                            </li>
                            <li class="x-navbar-panel-body">
                                <div class="x-navbar-panel-column">
                                    <div class="x-navbar-mega-menu-column" v-if="$can('edit.websites') || ( $can('manager.blog') && settings.hasBlog ) ">
                                        <h4 class="font-blue">Website</h4>
                                        <a href="/website-settings/general" v-if="$can('edit.websites')">Configurações do website</a>
                                        <a href="/website-settings/model" v-if="$can('edit.websites')">Logo e cores</a>
                                        <a href="/seo" v-if="$can('edit.websites')">Meta Tags</a>
                                        <a href="/popups" v-if="$can('edit.websites')">Popups</a>
                                        <a href="/testimonials" v-if="$can('edit.websites')">Depoimentos</a>
                                        <a href="/pages" v-if="$can('edit.websites')">Páginas extras</a>
                                        <a href="/url-redirects" v-if="$can('edit.websites')">Redirecionamento de URL</a>
                                        <a href="/banners" v-if="$can('edit.websites')">Banners</a>
                                        <a href="/watermark" v-if="$user.is_instance_owner">Marca d'água</a>
                                        <a href="/blog" v-if="$can('manager.blog') && settings.hasBlog">Blog</a>
                                    </div>
                                    <div class="x-navbar-mega-menu-column"
                                         v-if="$can('edit.portals') || $can('edit.websites')">
                                        <h4 class="font-blue">Integrações</h4>
                                        <a :href="portalsUrl" v-if="$can('edit.portals')">Portais</a>
                                        <a href="/website-settings/social" v-if="$can('edit.websites')">Redes
                                            Sociais</a>
                                    </div>
                                    <div class="x-navbar-mega-menu-column" v-if="$can('marketing.investment')">
                                        <h4 class="font-blue">Marketing</h4>
                                        <a href="/marketing/configs/investment">Investimento</a>
                                    </div>
                                </div>
                                <div class="x-navbar-panel-column">
                                    <div class="x-navbar-mega-menu-column">
                                        <h4 class="font-blue">Sistema</h4>
                                        <a href="/installments" v-if="$can('manager.billing')">Meus Boletos</a>
                                        <a href="/users" v-if="$can('edit.users')">Usuários</a>
                                        <a href="/teams" v-if="$can('edit.teams')">Equipes</a>
                                        <a href="/branches" v-if="$can('edit.teams')">Matriz e Filiais</a>
                                        <a href="/goals" v-if="$can('edit.users')">Metas</a>
                                        <a href="/form-routing" v-if="$can('edit.users')">Rodízio de
                                            atendimentos</a>
                                        <div>
                                            <a href="/form-routing-history"
                                               v-if="$can('manager.forms')"
                                               v-tooltip title="Essa função está em Beta e pode apresentar instabilidades">
                                                Histórico do rodízio
                                            </a>
                                        </div>
                                        <div>
                                            <a href="/inbox"
                                               v-if="$can('view.inbox')"
                                               v-tooltip title="Essa função está em Beta e pode apresentar instabilidades">
                                                Caixa de E-mails
                                            </a>
                                        </div>
                                        <a href="/files" v-if="$can('edit.websites')">Biblioteca de arquivos</a>
                                    </div>
                                    <div class="x-navbar-mega-menu-column">
                                        <h4 class="font-blue">Configurações</h4>
                                        <a href="/notifications">Alertas e Notificações</a>
                                        <a href="javascript:;" v-if="exact('/')"
                                           v-on:click.prevent="showSettingsModal()">Área de trabalho</a>
                                        <a v-if="!exact('/')" href="/#settings">Área de trabalho</a>
                                        <a v-if="$can('edit.users')" href="/system-settings">Gerais</a>
                                        <a v-if="$can('manager.webhooks')" href="/webhooks">Webhooks</a>
                                    </div>
                                    <div class="x-navbar-mega-menu-column" v-if="$can('marketing.investment') && canSeeReports()">
                                        <h4 class="font-blue">Relatórios</h4>
                                        <a href="/reports">Inteligência</a>
                                        <a href="/summaries/property-by-status">Imóveis por Status</a>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="x-navbar-group x-navbar-account">
                    <div class="x-navbar-link x-navbar-dropdown">
                        <a :href="'/users/' + $user.id"
                           data-close-others="true"
                           data-toggle="dropdown"
                           class="dropdown-toggle x-navbar-user-chip" v-el:menu-toggler>
                            <simple-user></simple-user>
                        </a>
                        <ul class="dropdown-menu" style="right: 0; left: auto">
                            <li style="padding-left: 15px; padding-right: 15px; padding-top: 15px; margin-bottom: 8px">
                                <detailed-user></detailed-user>
                            </li>
                            <li>
                                <a :href="'/users/' + $user.id" style="overflow: hidden;text-overflow: ellipsis;">
                                    Meus dados
                                </a>
                            </li>
                            <li>
                                <a href="/terms/tos" style="overflow: hidden;text-overflow: ellipsis;">
                                    Termos de uso
                                </a>
                                <a href="/terms/privacy_policy" style="overflow: hidden;text-overflow: ellipsis;">
                                    Política de Privacidade
                                </a>
                            </li>
                            <li class="divider"></li>
                            <li>
                                <a href="/logout">Sair</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    const R = require('ramda')
    const Vue = require('vue')
    const SCI = require('sci')
    const $ = require('jquery')
    const {client} = require('sci/helpers')
    const XNotifications = require('components/notifications/Navbar.vue')
    const XTasks = require('components/queue/Navbar.vue')
    const SimpleUser = require('./TopNavbar/SimpleUser.vue')
    const DetailedUser = require('./TopNavbar/DetailedUser.vue')
    const Mousetrap = require('mousetrap')
    const interfaceOptions = require('sci/helpers/interface-options')

    let previousMargin = []

    export default {
        components: {
            NavbarMenuIcon: require('./NavbarMenuIcon.vue'),
            NewSearchButton: require('components/property/NewSearchButton.vue'),
            XNotifications,
            XTasks,
            SimpleUser,
            DetailedUser
        },
        data() {
            const instance = SCI.get('instance');
            console.log(instance)
            return {
                preferences: interfaceOptions.state,
                registeredTopMargin: previousMargin,
                requiredTopMargin: 0,
                menuVisible: false,
                portals: [],
                portalPaletteAliases: [],
                funnels: [],
                settings: {
                    properties: {
                        'approval': instance.overrides["sci.settings.properties.approval"]
                    },
                    hasAlbert: instance.overrides['albert'],
                    hasBlog: instance.overrides['blog'],
                    code: instance.code,
                    useNewPortals: instance.overrides['sci.settings.portals.use_new_portals'] === true,
                    useNewForms: instance.overrides['sci.settings.forms.use_new_forms'] === true
                }
            }
        },
        ready() {
            this.disposeMenuTransitions = require('./TopNavbar/transitions')(this.$el)
            interfaceOptions.load()
            if (this.$can('edit.portals')) {
                client.silent().get(null, '/portals/list-installed').then((res) => {
                    this.portals = R.sortBy(_ => _.name, res.data)
                })
                // Match the React portal cards: palette follows catalog order,
                // including uninstalled portals, before the menu is sorted.
                client.silent().get(null, '/portals/list').then((res) => {
                    this.portalPaletteAliases = res.data.map(portal => portal.alias)
                }).catch((error) => {
                    console.error('Falha ao carregar as cores dos portais', error)
                })
            }

            this.loadFunnels()

            Mousetrap.bind('f2', (e) => {
                $(this.$els.menuToggler).click()
                return false
            })

            SCI.bus().$on('remove-top-margin', ({id}) => {
                this.registeredTopMargin = this.registeredTopMargin.filter((i) => {
                    return i.id !== id
                })
                previousMargin = this.registeredTopMargin

                this.calculateTopMargin()
            })

            SCI.bus().$on('push-top-margin', ({id, size}) => {
                this.registeredTopMargin.push({id, size})

                previousMargin = this.registeredTopMargin

                this.calculateTopMargin()
            })

            this.calculateTopMargin()
        },
        beforeDestroy() {
            if (this.disposeMenuTransitions) this.disposeMenuTransitions()
        },
        computed: {
            propertySearchUrl() {
                return interfaceOptions.searchUrl()
            },
            propertyDraftsUrl() {
                return interfaceOptions.searchUrl(true)
            },
            website() {
                if (this.$user.websites && this.$user.websites.length > 0) {
                    return this.$user.websites[0]
                }

                return null
            },
            portalsUrl() {
                return this.settings.useNewPortals ? '/portals/new' : '/portals'
            },
            formsUrl() {
                return this.settings.useNewForms ? '/forms/new' : '/forms'
            }
        },
        methods: {
            loadFunnels() {
                if (this.settings.useNewForms && this.$can('view.forms')) {
                    client.silent().get(null, '/forms/groups').then((res) => {
                        this.funnels = res.data || []
                    }).catch((error) => {
                        console.error('Falha ao carregar funis da navbar', error)
                        this.funnels = []
                    })
                }
            },
            toggleMenu() {
                this.menuVisible = !this.menuVisible
            },
            portalBadge(portal) {
                const name = portal.name || portal.alias || ''
                const key = `${portal.alias || ''} ${name}`.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()
                const catalogIndex = this.portalPaletteAliases.indexOf(portal.alias)
                const index = catalogIndex >= 0 ? catalogIndex : Math.max(0, this.portals.indexOf(portal))
                const variant = 'palette-' + (index % 4)
                if (/imovel\s*web/.test(key)) return { initials: 'IW', variant }
                if (/olx/.test(key)) return { initials: 'OLX', variant }
                if (/chaves/.test(key)) return { initials: 'CNM', variant }
                const words = name.split(/[^a-zA-ZÀ-ÿ0-9]+/).filter(word => word && !/^(de|da|do|das|dos|e)$/i.test(word))
                const initials = words.length > 1 ? words.slice(0, 3).map(word => word[0]).join('') : name.slice(0, 2)
                return { initials: initials.toUpperCase(), variant }
            },
            portalUrl(alias) {
                return this.settings.useNewPortals ? `/portals/new/${alias}/select-properties` : `/portals/${alias}/select-properties`
            },
            match(path) {
                return location.pathname.startsWith(path)
            },
            exact(path) {
                return location.pathname === path
            },
            canSeeReports() {
                if (this.$user) {
                    const user = this.$user

                    return user.type === 3 || user.is_instance_owner || this.$can('view.reports')
                }
                return false
            },
            showSettingsModal() {
                SCI.bus().$emit('dashboard:show-settings-modal')
            },
            calculateTopMargin() {
                this.requiredTopMargin = this.registeredTopMargin.reduce((a, b) => {
                    return a + b.size
                }, 0) + 'px'

                window.$requiredTopMargin = this.registeredTopMargin.reduce((a, b) => {
                    return a + b.size
                }, 0)
            }
        }
    }
</script>



// WEBPACK FOOTER //
// TopNavbar.vue?d7331da4